import { createFileRoute } from "@tanstack/react-router";

import { AdminProvidersPage } from "@/components/admin/AdminProvidersPage";

export const Route = createFileRoute("/admin/providers")({
  head: () => ({ meta: [{ title: "Providers - GENRL Admin" }] }),
  component: AdminProvidersPage,
});
